import { QrCodeIcon, Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function Team() {

  const navigate = useNavigate();
  const [team, setTeam] = useState([]);
  const [addTeam, setAddTeam] = useState(null);
  const [editId, setEditId] = useState(null);
  
  const [formDataTeam, setFormDataTeam] = useState({ name: '', division: '' , photo:'', ig:'', nik:'', ttl:'', quotes:'', link_qr:''});

  const handleAdd = (event) => {
    setAddTeam(event);
    setFormDataTeam({ name: event.name, division: event.division, photo:event.photo, ig:event.ig , ttl:event.ttl , nik:event.inik , quotes:event.quotes , link_qr:event.link_qr  });
  };

  const fetchTeam = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/teams/list`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setTeam(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchTeam();
  }, []);

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataTeam({
      name: item.name,
      division: item.division,
      ig: item.ig,
      ttl: item.ttl,
      nik: item.nik,
      quotes: item.quotes,
      link_qr: item.link_qr,
      photo: null, // kosongkan dulu file upload
    });

    setAddTeam(true); // buka modal
  };

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("name", formDataTeam.name);
      formData.append("division", formDataTeam.division);
      formData.append("ig", formDataTeam.ig);
      formData.append("photo", formDataTeam.photo);
      formData.append("nik", formDataTeam.nik);
      formData.append("ttl", formDataTeam.ttl);
      formData.append("quotes", formDataTeam.quotes);
      formData.append("link_qr", formDataTeam.link_qr);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/teams/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataTeam({
          name: "",
          division: "",
          ig: "",
          ttl: "",
          nik: "",
          quotes: "",
          link_qr: "",
          photo: "",
        });

        setAddTeam(null);
        await fetchTeam();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Personel berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };
  
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Personel ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/teams/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Personel berhasil dihapus.', 'success');
            fetchTeam();
          });
      }
    });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("name", formDataTeam.name);
      formData.append("division", formDataTeam.division);
      formData.append("ig", formDataTeam.ig);
      formData.append("photo", formDataTeam.photo);
      formData.append("nik", formDataTeam.nik);
      formData.append("ttl", formDataTeam.ttl);
      formData.append("quotes", formDataTeam.quotes);
      formData.append("link_qr", formDataTeam.link_qr);

      // hanya kirim icon jika ada file baru
      if (formDataTeam.photo) {
        formData.append("photo", formDataTeam.photo);
      }

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/teams/${editId}`,
        {
          method: "POST", // CI4 biasanya POST untuk update
          body: formData,
        }
      );

      const result = await response.json();

      if (response.ok) {

        await fetchTeam(); // refresh data
        
        setAddTeam(null);
        await fetchTeam();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Personel berhasil diupdate!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal update");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-slate-950 text-white pt-20">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-red-400 bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-red-500 mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-slate-950"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col'>
              <div className='p-4 text-xl font-medium'>
                List Personel tim Radar Pulsa
              </div>
              <div className='flex flex-row p-4'>
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-blue-400 to-red-400  text-transparent">
                    <tr>
                      <th class="p-4 font-medium text-gray-900 text-center">Nama</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Divisi/Posisi</th>
                      <th class="p-4 font-medium text-gray-900 text-center">Akun IG</th>
                      <th class="font-medium text-gray-900 text-center">Photo</th>
                      <th class="font-medium text-gray-900 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody class="divide-y divide-gray-200">
                    {Array.isArray(team) && team.map((a, idx) => (
                      <>
                        <tr class="hover:bg-gray-500">
                          <td class="p-4  text-white text-center">{a.name}</td>
                          <td class="p-4 text-white text-center">{a.division}</td>
                          <td class="p-4 text-white text-center">{a.ig}</td>
                          <td class="p-4 text-white text-center">
                            <img className='max-h-96' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.photo}`} />
                          </td>
                          <td class="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaPencil onClick={() => handleEditClick(a)} className='cursor-pointer'></FaPencil> 
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                              {a.link_qr && (
                                <a href={`/p/${a.link_qr}`}
                                  target="_blank"
                                  className="">
                                    <QrCodeIcon className='cursor-pointer'></QrCodeIcon>
                                </a>
                              )}
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {addTeam && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
          onClick={() => {
            setAddTeam(null);
            setEditId(null);
          }}
        >
          <div
            className="bg-white text-black p-6 rounded-2xl w-full max-w-lg relative shadow-2xl max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
              onClick={() => {
                setAddTeam(null);
                setEditId(null);
              }}
            >
              <X size={20} />
            </button>

            {/* Title */}
            <h3 className="text-xl font-bold mb-6 text-center">
              {editId
                ? "Edit Personel Radar Pulsa"
                : "Tambah Personel Radar Pulsa"}
            </h3>

            {/* Form */}
            <form
              onSubmit={editId ? handleUpdate : handleInsert}
              className="space-y-4"
            >
              {/* Title */}
              <div>
                <label className="block font-medium mb-1">Nama</label>
                <input
                  type="text"
                  value={formDataTeam.name}
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      name: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block font-medium mb-1">Division/Posisi</label>
                <input
                  type="text"
                  value={formDataTeam.division}
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      division: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  required
                />
              </div>
              <div>
                <label className="block font-medium mb-1">NIK (Nomor Induk Karyawan)</label>
                <input
                  type="text"
                  value={formDataTeam.nik}
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      nik: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Tempat, Tanggal Lahir</label>
                <input
                  type="text"
                  value={formDataTeam.ttl}
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      ttl: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  placeholder="Contoh: Bandung, 1 Januari 2000"
                  
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Quotes</label>
                  <textarea
                    name='quotes'
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={formDataTeam.quotes}
                    onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      quotes: e.target.value,
                    })
                  }
                    
                    rows={4}
                  />
              </div>

              <div>
                <label className="block font-medium mb-1">Akun IG</label>
                <input
                  type="text"
                  value={formDataTeam.ig}
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      ig: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  
                />
              </div>
              <div>
                <label className="block font-medium mb-1">Link Scan QR</label>
                <input
                  type="text"
                  value={formDataTeam.link_qr}
                  placeholder="contoh: john-doe"
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      link_qr: e.target.value,
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                  
                />
              </div>

              {/* Icon Upload */}
              <div>
                <label className="block font-medium mb-1">Photo</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    setFormDataTeam({
                      ...formDataTeam,
                      photo: e.target.files[0],
                    })
                  }
                  className="w-full border border-gray-300 p-2 rounded-lg"
                />
                
                <span className='text-sm text-red-600'><i>*rekomendasi file type: .png, .jpg, .jpeg</i></span>

                {/* Preview Image */}
                {formDataTeam.photo && (
                  <img
                    src={URL.createObjectURL(formDataTeam.photo)}
                    alt="preview"
                    className="mt-3 h-20 object-contain rounded-lg border"
                  />
                )}
              </div>

              {/* Buttons */}
              <div className="flex justify-end gap-3 pt-4">
                <button
                  type="button"
                  className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                  onClick={() => {
                    setAddTeam(null);
                    setEditId(null);
                  }}
                >
                  Batal
                </button>

                <button
                  type="submit"
                  className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                >
                  {editId ? "Update" : "Simpan"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default Team;
